import {get} from 'lodash-es';

import {IReferenceParamKey} from 'entities/metadata';

export const shouldPerformFieldUpdate = (
    previous: any, current: any, referenceParamsKeys?: IReferenceParamKey[],
) => referenceParamsKeys?.some(({from}) => from && get(previous, from) !== get(current, from));
